// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._16jlidpf{flex-grow:0}
._18u0idpf{margin-left:0}
._19pk1b66{margin-top:var(--ds-space-050,4px)}
._1bah1h6o{justify-content:center}
._1bsb7vkz{width:1pc}
._1e0c1txw{display:flex}
._1o9zidpf{flex-shrink:0}
._2hwxutpp{margin-right:var(--ds-space-150,9pt)}
._4cvr1h6o{align-items:center}
._4t3i7vkz{height:1pc}
._i0dlexct{flex-basis:16px}
._otyridpf{margin-bottom:0}
._syaz1oju{color:var(--ds-icon-subtle,#626f86)}
._syaz1yjp{color:var(--ds-icon-success,#22a06b)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/task-decision/dist/esm/components/DecisionItem.compiled.css"],"names":[],"mappings":"AAAA,WAAW,WAAW;AACtB,WAAW,aAAa;AACxB,WAAW,kCAAkC;AAC7C,WAAW,sBAAsB;AACjC,WAAW,SAAS;AACpB,WAAW,YAAY;AACvB,WAAW,aAAa;AACxB,WAAW,oCAAoC;AAC/C,WAAW,kBAAkB;AAC7B,WAAW,UAAU;AACrB,WAAW,eAAe;AAC1B,WAAW,eAAe;AAC1B,WAAW,mCAAmC;AAC9C,WAAW,oCAAoC","sourcesContent":["._16jlidpf{flex-grow:0}\n._18u0idpf{margin-left:0}\n._19pk1b66{margin-top:var(--ds-space-050,4px)}\n._1bah1h6o{justify-content:center}\n._1bsb7vkz{width:1pc}\n._1e0c1txw{display:flex}\n._1o9zidpf{flex-shrink:0}\n._2hwxutpp{margin-right:var(--ds-space-150,9pt)}\n._4cvr1h6o{align-items:center}\n._4t3i7vkz{height:1pc}\n._i0dlexct{flex-basis:16px}\n._otyridpf{margin-bottom:0}\n._syaz1oju{color:var(--ds-icon-subtle,#626f86)}\n._syaz1yjp{color:var(--ds-icon-success,#22a06b)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
